/**
 * Profile Guard
 *
 * Protects routes that require a user to have a profile set up for the active team.
 * If the user does not have a profile, redirects to /workspace/no-profile.
 *
 * This guard should be used on admin routes that require profile data.
 *
 * @example
 * {
 *   path: 'workspace',
 *   canActivate: [authGuard, profileGuard],
 *   component: AdminComponent
 * }
 */

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AccountState } from 'src/app/store/account/account.state';

/**
 * Profile Guard
 *
 * Checks if the user has a profile for the active team.
 * If not, redirects to /workspace/no-profile.
 */
export const profileGuard: CanActivateFn = (route, state) => {
  const accountState = inject(AccountState);
  const router = inject(Router);

  const requestedRoute = state.url;
  
  // Get active team and profile from signal-based AccountState
  const activeTeam = accountState.activeTeam();
  const activeProfile = accountState.activeProfile();
  const activeTeamId = activeTeam?.id;


  // Check if user has a profile for the active team
  if (!activeProfile) {
    router.navigate(['/my-blume']);
    return false;
  }

  // User has profile - allow access
  return true;
};

